const registerFocusable = (id, input) => () => {
}, unregisterFocusable = (id) => {
}, focusFocusable = (id) => {
};
export {
  focusFocusable,
  registerFocusable,
  unregisterFocusable
};
//# sourceMappingURL=registerFocusable.js.map
